/**
 * Returns true if the email contains an @ and also a '.' AFTER that @
 * This is meant to be used in conjunction with the default <input type="email"> validation which covers most other cases
 * @param email
 * @returns true if valid email, false if not
 */
export const isValidEmail = (email: string): boolean => {
  const splitEmail = email.split('@');

  if (splitEmail.length < 2) {
    return false;
  }

  const emailDomain = splitEmail[1];

  if (!emailDomain.includes('.')) {
    return false;
  }

  return true;
};
